<div class="agent-step__citation-header">
  <div class="agent-step__citation-title">
    <img [src]="resourceTypeIcon()" alt="attachment icon" class="agent-step__citation-icon" />
    {{ citation()?.resourceType === CitationResourceType.FILE ? citation()?.fileName ?? ('common.noFileName' | labelsProvider) : 'Website' }}
  </div>
  @if (sensitivity(); as sensitivity) {
    <div class="agent-step__citation-sensitivity">
      <img [src]="sensitivity.icon" alt="sensitivity icon" class="agent-step__citation-sensitivity-icon" />
      <div>{{ sensitivity.label }}</div>
    </div>
  }
</div>
@if (citation()?.link; as link) {
  <app-anchor-link [navigation]="link" class="agent-step__citation-link">
    {{ link }}
  </app-anchor-link>
}

@if (citation()?.sensitiveData; as sensitiveData) {
  <app-get-sensitive-data-input-action
    [sensitiveDataMethod]="sensitiveData.sensitiveDataMethod"
    [showPopupBtn]="!!sensitiveData.showPopupBtn"
    class="agent-step__citation-sensitive-data"
  />
}
